import { RIGHT_SECTION_KEYS } from "@utils/globalCommon";
import usePageData from "@hooks/usePageData";

import Audits from "@components/Audits";
import Contracts from "@components/Contracts";
import Utilities from "@components/Utilities";
import Platform from "@components/Platform";
import Dashboard from "@components/Dashboard";
import Subscribe from "@components/Subscribe";
import ETHUtilities from "@components/ETHUtilities";
import { useDappSDKProvider } from "dapp-sdk-v2";

const RightSection = () => {
  const { isConnected } = useDappSDKProvider();
  const right_sections =
    usePageData("$.page.data.right_sections.data")[0] || [];

  right_sections.sort(
    (a: any, b: any) => a.attributes.sort_key - b.attributes.sort_key
  );

  const getRightSection = (sectionKey: string) => {
    switch (sectionKey) {
      case RIGHT_SECTION_KEYS.AUDITS:
        return <Audits />;
      case RIGHT_SECTION_KEYS.CONTRACTS:
        return <Contracts />;
      case RIGHT_SECTION_KEYS.UTILITIES:
        return <Utilities />;
      case RIGHT_SECTION_KEYS.PLATFORM:
        return <Platform />;
      case RIGHT_SECTION_KEYS.SUBSCRIPTION:
        return <Subscribe />;
      case RIGHT_SECTION_KEYS.ETHXSTATISTICS:
        return <ETHUtilities />;
    }
  };
  return (
    <>
      {right_sections.some(
        (data: { attributes: { key: string } }) =>
          data?.attributes?.key === "dashboard"
      ) && isConnected ? (
        <Dashboard />
      ) : null}
      {right_sections.map(
        (section: { attributes: { key: any } }, index: number) => {
          const sectionKey = section?.attributes?.key;
          return sectionKey === "dashboard" ? null : (
            <div key={sectionKey || index}>{getRightSection(sectionKey)}</div>
          );
        }
      )}
    </>
  );
};

export default RightSection;
